export default __webpack_public_path__ + "static/media/dark-linkedIn.d36b2f5b.svg";